// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1rN_s","footer":"ReportModalFilter_footer__1qWOB"};